import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { Communication } from '@lr/data-access';

@Component({
  selector: 'lib-communication-alert',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule
  ],
  templateUrl: './communication-alert.component.html',
  styleUrls: ['./communication-alert.component.scss']
})
export class CommunicationAlertComponent {
  @Input() communication!: Communication;
  private router = inject(Router);

  get alertClass(): string {
    switch (this.communication.priority) {
      case 'Warning':  return 'alert-warning';
      case 'Critical': return 'alert-critical';
      case 'Info':     return 'alert-info';
      default:         return 'alert-info';
    }
  }

  get alertIcon(): string {
    switch (this.communication.priority) {
      case 'Warning':  return 'warning';
      case 'Critical': return 'error';
      case 'Info':     return 'info';
      default:         return 'info';
    }
  }

  onViewInvoices(): void {
    this.router.navigate(['/billing/invoices']);
  }
}
